import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/mock';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="faq-item">
      <button
        className="faq-question w-full text-left"
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <span className="heading-3 pr-4">{question}</span>
        <ChevronDown 
          size={20} 
          className={`flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="faq-answer body-regular">
          {answer}
        </div>
      </div>
    </div>
  );
};

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faqs" className="section-padding">
      <div className="container px-4 sm:px-10">
        {/* Section Header */}
        <div className="section-title">
          <p className="eyebrow-gold uppercase tracking-widest mb-4">
            Common Questions
          </p>
          <h2 className="heading-1">Frequently Asked Questions</h2>
        </div>
        
        {/* FAQ List */}
        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
            />
          ))}
        </div>
        
        {/* Disclaimer */}
        <div className="max-w-3xl mx-auto mt-12 p-6 bg-[var(--bg-secondary)] border border-[var(--border-light)]">
          <p className="body-small text-[var(--text-light)]">
            <strong>Disclaimer:</strong> Claim settlement is subject to insurer terms and policy conditions. 
            Protection Guardianship™ provides advisory services, not insurance products. 
            We do not guarantee claim approvals or policy outcomes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
